import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ".././../../styles/layouts/footer/_footerCategoriesRoutingComponent.scss";

const FooterCategoriesRoutingComponent = () => {
  const categories = useSelector((state) => state.categoryReducer.categories?.items);

  if (!categories) return null;

  return (
    <div className="footerCategoriesContainer">
      <div className="categoriesListContainer">
        {categories.map((category) => (
          <div className="categoryContainer" key={category.id}>
            <Link to={`/categories/${category.id}`} className="categoryHeader">
              {category.categoryName}
            </Link>
            {category.itemGroups.length > 0 && (
              <div className="subCategoryContainer">
                {category.itemGroups.map((group) => (
                  <Link key={group.id} to={`/categories/${category.id}/itemGroup/${group.id}`} className="subCategoryTitle">
                    {group.itemGroupName}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterCategoriesRoutingComponent;
